import AccessResponse from "admin/types/interfaces/access";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

const useUserAccess = (email: string) => {
  return useFetcher<AccessResponse>(`${VITE_ACCESS_CONTROLLER_API}/users/${email}/access`);
};

export default useUserAccess;
